import { Permission } from '@today/types'
import type { RouteObject } from 'react-router-dom'
import { RequirePermission } from '@/components/RequirePermission'
import { NotificationTemplatesPage } from './NotificationTemplatesPage'

/** Child of the `/t/:slug/admin` route (TO-140 REQ-011): gated on `notification_templates.manage`. */
export const notificationTemplatesRoute: RouteObject = {
	path: 'notification-templates',
	element: (
		<RequirePermission permission={Permission.NOTIFICATION_TEMPLATES_MANAGE}>
			<NotificationTemplatesPage />
		</RequirePermission>
	),
}
